module.exports = __webpack_public_path__ + "static/img/mouseTip.2b95389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mouseTip.png
// module id = GA38
// module chunks = 1